import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useApp } from '../context/AppContext';
import './ExhibitionCarousel.css';

export default function ExhibitionCarousel() {
  const { lang } = useApp();
  const isAr = lang === 'ar';

  const [slides, setSlides]   = useState([]);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused]   = useState(false);

  useEffect(() => {
    axios.get('/api/exhibition-slides').then(r => {
      if (Array.isArray(r.data) && r.data.length) setSlides(r.data);
    }).catch(() => {});
  }, []);

  const next = useCallback(() => setCurrent(c => (c + 1) % slides.length), [slides.length]);
  const prev = ()           => setCurrent(c => (c - 1 + slides.length) % slides.length);

  useEffect(() => {
    if (paused || slides.length === 0) return;
    const t = setInterval(next, 4000);
    return () => clearInterval(t);
  }, [paused, next, slides.length]);

  if (!slides.length) return null;

  const titleAr = '30 شهراً — وما زالت الذاكرة تنبض';
  const titleEn = '30 Months — Memory Still Pulses';
  const subAr   = 'بالحكايات والألوان';
  const subEn   = 'with Stories and Colours';

  return (
    <section className="exh-section">
      <div className="exh-header">
        <span className="eyebrow exh-eyebrow">
          {isAr ? 'المعرض الثلاثون' : '30th Exhibition'}
        </span>
        <h2 className="exh-title">
          {isAr ? titleAr : titleEn}
          <em>{isAr ? subAr : subEn}</em>
        </h2>
      </div>

      <div
        className="exh-track-wrap"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <button className="exh-arrow left" onClick={prev} aria-label="Previous">‹</button>

        <div className="exh-track">
          {slides.map((s, i) => (
            <div
              key={s.id}
              className={`exh-slide${i === current ? ' active' : ''}${
                i === (current - 1 + slides.length) % slides.length ? ' prev' : ''
              }`}
            >
              <img src={s.image_url} alt={s.artist_name || s.title_ar || ''} />
              {(s.artist_name || s.title_ar) && (
                <div className="exh-caption">
                  {s.title_ar && <span className="exh-artwork-title">{s.title_ar}</span>}
                  {s.artist_name && <span className="exh-artist">{s.artist_name}</span>}
                </div>
              )}
            </div>
          ))}
        </div>

        <button className="exh-arrow right" onClick={next} aria-label="Next">›</button>
      </div>

      <div className="exh-dots">
        {slides.map((s, i) => (
          <button
            key={s.id}
            className={`exh-dot${i === current ? ' active' : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
